import axios from 'axios';
import { http } from './http';

export type BillingStatus =
  | 'none'
  | 'active'
  | 'trialing'
  | 'past_due'
  | 'canceled'
  | 'unpaid';

export interface BillingContext {
  editor: string;
  status: BillingStatus;
  currentSeatCount: number;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  stripePriceId: string | null;
  perSeatPriceId: string | null;
  stripeEnabled: boolean;
}

const BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

/** Exchange client credentials for a short-lived Bearer token. */
export async function login(
  clientId: string,
  clientSecret: string,
): Promise<{ access_token: string; expires_in: number }> {
  const { data } = await axios.post(`${BASE}/api/v1/crm/auth/token`, {
    grant_type: 'client_credentials',
    client_id: clientId,
    client_secret: clientSecret,
  });
  return data as { access_token: string; expires_in: number };
}

/** Returns the authenticated editor's billing context. */
export async function fetchBillingContext(): Promise<BillingContext> {
  const { data } = await http.get('/api/v1/crm/billing/context');
  return data as BillingContext;
}

/** Creates a Stripe Checkout session and returns the redirect URL. */
export async function createCheckout(params: {
  successUrl: string;
  cancelUrl: string;
  contactEmail?: string;
}): Promise<{ url: string }> {
  const { data } = await http.post('/api/v1/crm/billing/checkout', params);
  return data as { url: string };
}

/** Creates a Stripe Billing Portal session and returns the redirect URL. */
export async function createPortal(params: {
  returnUrl: string;
  contactEmail?: string;
}): Promise<{ url: string }> {
  const { data } = await http.post('/api/v1/crm/billing/portal', params);
  return data as { url: string };
}
